<template>
  <form-wrapper :validator="$v.items">
    <b-modal
      id="donate"
      ref="donate"
      title="Donate"
      hide-footer>

      <div class="col-md-12">

        <b-form-group
          input-cols="7"
          :label="$t('message.lblMail')">
          <b-form-input
            v-model="items.email"
            plaintext/>
        </b-form-group>

        <text-group
          :input-cols="7"
          v-for="(item, key) in textGroupItems"
          :key="key"
          :align-right="false"
          :m="items"
          :name="key"
          :select="item.select"
          :label="item.label" />

        <b-form-group
          input-cols="7"
          name="country"
          :label="$t('message.lblStat')">
          <template slot-scope="{ attrs, listeners }">
            <b-form-select
              class="alignL"
              v-bind="attrs"
              v-model="items.country"
              :options="kraj"
              v-on="listeners" />
          </template>
        </b-form-group>

        <b-form-group
          input-cols="7"
          name="amount"
          label="Suma:">
          <template slot-scope="{ attrs, listeners }">
            <b-form-select
              class="alignL"
              v-bind="attrs"
              v-model="items.amount"
              :options="sumas"
              v-on="listeners" />
          </template>
        </b-form-group>

        <b-form-group
          input-cols="7"
          name="suhlas"
          label="">
          <template slot-scope="{ attrs, listeners }">
            <b-form-checkbox
              v-bind="attrs"
              v-model="items.suhlas"
              value="1"
              unchecked-value="0"
              plain
              v-on="listeners">
              {{ $t('message.lblSuhlas') }}
            </b-form-checkbox>
          </template>
        </b-form-group>

        <b-btn
          class="mt-3 downloadButton"
          block
          @click="save">
          PRISPIEŤ
        </b-btn>

      </div>
    </b-modal>

    <form
      v-show="false"
      ref="paymentForm"
      :action="postUrl"
      method="post">

      <payment-form
        :items="paymentItems" />
    </form>
  </form-wrapper>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import restEditor from '@/mixins/restEditor'
import textGroup from '@/components/extractor/textGroup.vue'
import bFormGroup from '@/components/form-group-col6'
import paymentForm from '@/wizardElements/download/paymentForm.vue'

export default {

  components: {
    bFormGroup,
    textGroup,
    paymentForm,
  },

  mixins: [restEditor],

  data() {
    return {
      dType: 'a',
      money: null,
      id: null,
      items: {
        email: null,
        firstName: null,
        familyName: null,
        country: 'SVK',
        amount: null,
        suhlas: null,
        subjectId: null,
      },
      sumas: [
        { value: null, text: this.$t('message.msgSelect') },
        { value: '2.50', text: '2.50€' },
        { value: '3.50', text: '3.50€' },
        { value: '4.50', text: '4.50€' },
        { value: '5.50', text: '5.50€' },
      ],
      paymentItems: {},
      postUrl: null,
      kraj: [],
      textGroupItems: {
        firstName: { label: this.$t('message.lblMeno') },
        familyName: { label: this.$t('message.lblPriez') },
      },
    };
  },

  validations: {
    items: {
      email: {},
      firstName: { required },
      familyName: { required },
      country: { required },
      amount: { required },
      suhlas: { required },
    },
  },

  methods: {
    async processGet() {
      if (this.$store.state.domain === 'jedno') {
        this.kraj = await this.restDataSource.listObject('countries/code3');
        const profileItems = await this.restDataSource.listObject('profiles/own');
        this.items.email = profileItems.email;
        this.items.firstName = profileItems.first_name;
        this.items.familyName = profileItems.last_name;
        this.$store.commit('setMembership', profileItems.activeMembership);
      }
    },

    async processSave() {
      await this.pay();
    },

    async pay() {
      this.items.subjectId = this.$route.params.userId;
      const response = await this.restDataSource.postPayment(this.items);

      this.paymentItems = response.params;
      this.postUrl = response.postUrl;

      this.$nextTick(() => {
        this.$refs.paymentForm.submit();
      });
    },
  },
};
</script>

<style>
label.form-check-label {
  width: 100%;
}
</style>
